/* Hemdem Akademi – ana sayfa: carousel ve ISBN ile hızlı sipariş */
(function () {
  'use strict';
  function initCarousel(root) {
    if (root.dataset.hmInit) return; root.dataset.hmInit = '1';
    var slides = Array.prototype.slice.call(root.querySelectorAll('.hm-slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.hm-car__dot'));
    if (slides.length < 2) return;
    var cur = 0, timer = null;
    var interval = parseInt(root.getAttribute('data-interval') || '6', 10) * 1000;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function go(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.setAttribute('aria-hidden', k === cur ? 'false' : 'true'); });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === cur ? 'true' : 'false'); });
      restart();
    }
    function activeVideo() {
      var s = slides[cur];
      if (!s || !s.hasAttribute('data-video-slide')) return null;
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      return s.querySelector(mobile ? '.hm-vslide__v--m' : '.hm-vslide__v--d') || s.querySelector('video');
    }
    function restart() {
      if (timer) clearTimeout(timer);
      root.querySelectorAll('[data-video-slide] video').forEach(function (v) { v.pause(); v.onended = null; });
      var auto = !reduce && root.getAttribute('data-autoplay') === 'true';
      var v = activeVideo();
      if (v) {
        try { v.currentTime = 0; } catch (e) {}
        v.muted = true;
        if (auto) v.onended = function () { go(cur + 1); };
        var p = v.play();
        if (p && p.catch) p.catch(function () { if (auto) timer = setTimeout(function () { go(cur + 1); }, interval * 3); });
        return;
      }
      if (!auto) return;
      timer = setTimeout(function () { go(cur + 1); }, interval);
    }
    var prev = root.querySelector('.hm-car__arrow--prev'), next = root.querySelector('.hm-car__arrow--next');
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    go(0);
  }
  function initQuickOrder(form) {
    if (form.dataset.hmInit) return; form.dataset.hmInit = '1';
    var textarea = form.querySelector('textarea');
    var status = form.querySelector('.hm-quick__status');
    var button = form.querySelector('button[type="submit"]');
    function say(msg, isError) { status.textContent = msg; status.classList.toggle('hm-quick__status--error', !!isError); }
    function findProduct(isbn) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(isbn) + '&resources[type]=product&resources[limit]=3&resources[options][fields]=variants.barcode,variants.sku,title,body';
      return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (data) {
        var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) return null;
        var exact = products.filter(function (p) { return (p.handle || '').indexOf(isbn) !== -1; });
        return (exact[0] || products[0]).handle;
      });
    }
    function variantFor(handle) {
      return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
        return v ? { id: v.id, title: p.title } : null;
      });
    }
    function refreshCartIcon() {
      return fetch('/?sections=cart-icon-bubble', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (sections) {
        var html = sections && sections['cart-icon-bubble'];
        var target = document.getElementById('cart-icon-bubble');
        if (html && target) { var tmp = document.createElement('div'); tmp.innerHTML = html; var inner = tmp.querySelector('.shopify-section') || tmp; target.innerHTML = inner.innerHTML; }
      }).catch(function () {});
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var raw = (textarea.value || '').match(/\d[\d-]{8,16}\d/g) || [];
      var isbns = [];
      raw.forEach(function (s) { var n = s.replace(/-/g, ''); if ((n.length === 10 || n.length === 13) && isbns.indexOf(n) === -1) isbns.push(n); });
      if (!isbns.length) { say('Her satıra bir ISBN yazın (10 ya da 13 haneli).', true); return; }
      button.disabled = true;
      say(isbns.length + ' ISBN aranıyor…');
      var found = [], missing = [];
      var chain = Promise.resolve();
      isbns.forEach(function (isbn) {
        chain = chain.then(function () {
          return findProduct(isbn).then(function (handle) {
            if (!handle) { missing.push(isbn); return; }
            return variantFor(handle).then(function (v) { if (v) found.push(v); else missing.push(isbn); });
          }).catch(function () { missing.push(isbn); });
        });
      });
      chain.then(function () {
        if (!found.length) { say('Hiçbir ISBN eşleşmedi: ' + missing.join(', '), true); button.disabled = false; return; }
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: found.map(function (v) { return { id: v.id, quantity: 1 }; }) }) })
          .then(function (r) { return r.json(); }).then(function (res) {
            if (res && res.status) { say(res.description || res.message || 'Sepete eklenemedi.', true); button.disabled = false; return; }
            var msg = found.length + ' kitap sepete eklendi.';
            if (missing.length) msg += ' Bulunamayan: ' + missing.join(', ');
            say(msg, false);
            status.insertAdjacentHTML('beforeend', ' <a href="/cart">Sepete git</a>');
            textarea.value = missing.join('\n');
            button.disabled = false;
            refreshCartIcon();
          });
      }).catch(function () { say('Bir hata oluştu, lütfen tekrar deneyin.', true); button.disabled = false; });
    });
  }
  function init() {
    document.querySelectorAll('.hm-car').forEach(initCarousel);
    document.querySelectorAll('.hm-quick__form').forEach(initQuickOrder);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
